import constant from "@/constant";
const OrderCustomer = [
  {
    title: window.__t('js.hanh_dong'),
    key: "operation",
    fixed: "left",
    width: 110,
    isEditByUser: true,
    statusField: "status",
    actions: [
      {
        type: "edit",
        color: "#3f51b5",
        status: [0],
      },
      {
        type: "copy",
        color: "#66bb6a",
        status: [0, 1, 2],
      },
      {
        type: "delete",
        color: "#ee6e73",
        status: [0, 1],
      },
      {
        type: "cancel",
        color: "#ee6e73",
        status: [6],
      },
    ],
    slots: { customRender: "renderAction" },
  },
  {
    width: 150,
    title: window.__t('js.ma_don_hang'),
    fixed: "left",
    dataIndex: "code",
    isCodeIndex: true,
    isNameIndex: true,
    ellipsis: true,
  },
  {
    width: 180,
    title: window.__t('js.trang_thai'),
    fixed: "left",
    dataIndex: "status",
    dataType: "list",
    dataSource: constant.orderCustomerStatus,
    ellipsis: true,
    disableSearch: true,
  },
  {
    width: 200,
    title: window.__t('js.so_don_hang'),
    dataIndex: "order_no",
    dataType: "text",
  },
  {
    width: 200,
    title: window.__t('js.so_hoa_don'),
    dataIndex: "bill_nos",
    dataType: "text",
  },
  {
    width: 150,
    title: window.__t('js.ngay_dat_hang'),
    dataIndex: "order_date",
    dataType: "date",
    ellipsis: true,
    disableSearch: true,
  },

  {
    width: 200,
    title: window.__t('js.diem_nhan_hang'),
    dataIndex: "name_of_location_destination_id",
    originalIndex: "ld.title",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 180,
    title: window.__t('js.ngay_nhan_hang'),
    dataIndex: "ETD_date_time",
    dataType: "datetime",
    originalIndex: "ETD_date",
    ellipsis: true,
  },
  {
    width: 200,
    title: window.__t('js.diem_tra_hang'),
    dataIndex: "name_of_location_arrival_id",
    originalIndex: "la.title",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 180,
    title: window.__t('js.ngay_tra_hang'),
    dataIndex: "ETA_date_time",
    dataType: "datetime",
    originalIndex: "ETA_date",
    ellipsis: true,
  },
  {
    width: 200,
    title: window.__t('js.tong_quang_duong_km'),
    dataIndex: "distance",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: window.__t('js.tong_khoi_luong_kg'),
    dataIndex: "weight",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: window.__t('js.tong_dung_tich_m3'),
    dataIndex: "volume",
    dataType: "number",
    isBold: true,
  },
  {
    width: 200,
    title: window.__t('js.so_khung'),
    dataIndex: "vin_nos",
    dataType: "text",
  },
  {
    width: 200,
    title: window.__t('js.so_model'),
    dataIndex: "model_nos",
    dataType: "text",
  }
];

const Location = [
  {
    width: 150,
    title: window.__t('js.ma_dia_diem'),
    fixed: "left",
    dataIndex: "code",
    ellipsis: true,
  },
  {
    width: 200,
    title: window.__t('js.ten'),
    dataIndex: "title",
    isNameIndex: true,
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 200,
    ellipsis: true,
    title: window.__t('js.dia_chi'),
    dataIndex: "address",
    ellipsis: true,
    dataType: "text",
  },
  {
    width: 150,
    ellipsis: true,
    title: window.__t('js.tinh_thanh_pho'),
    dataIndex: "name_of_province_id",
    originalIndex: "province.title",
  },
  {
    width: 150,
    ellipsis: true,
    title: window.__t('js.quan_huyen'),
    dataIndex: "name_of_district_id",
    originalIndex: "district.title",
  },
  {
    width: 150,
    title: window.__t('js.xa_phuong'),
    dataIndex: "name_of_ward_id",
    originalIndex: "ward.title",
  },
  {
    width: 200,
    ellipsis: true,
    title: window.__t('js.kinh_do'),
    dataIndex: "latitude",
  },
  {
    width: 200,
    ellipsis: true,
    title: window.__t('js.vi_do'),
    dataIndex: "longitude",
  },
];


export default {
  OrderCustomer,
  Location,
};
